/**
 * DECLARATION DE FUNCTIONS
 */

(function ($) {
    $.fn.fancybox_images = function (params) {
        this.each(function () {
            $("a[href$='.jpg'], a[href$='.png'], a[href$='.jpeg'], a[href$='.gif'], a[href$='.svg']").fancybox({
                keyboard: true,
                loop: false,
                arrows: true,
                infobar: false,
                afterLoad: function (instance, current) {
                    var pixelRatio = window.devicePixelRatio || 1;

                    if (pixelRatio > 1.5) {
                        current.width = current.width / pixelRatio;
                        current.height = current.height / pixelRatio;
                    }
                }
            });
        });
    };
})(jQuery)

/**
 * DOM
 */
jQuery(document).ready(function ($) {
    /**
     * FUNCTIONS
     */
    $('body').fancybox_images();

    /**
     * ANIMATIONS
     */
    //wow
    new WOW({
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
    }).init();

    /**
     * scroll on click
     */
    $("a").on('click', function (event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $('html, body').animate({scrollTop: $(hash).offset().top - 150}, 400);
        }
    });

    /**
     * document load
     */
    $(window).load(function () {
        //nav mobile foldable
        $('nav.mobile .menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            $(this).next("ul").slideToggle();
            $(this).toggleClass("open");
        });

        $('.popup_btn').each(function () {
            var cible = $(this).attr('data-cible');
            $(this).click(function () {
                $("#" + cible).addClass('is-open');
                return false;
            });
        });

        $('.bloc_options .popupContainer .popup_close, .bloc_options .popupContainer .popup_cover').each(function () {
            $(this).click(function () {
                $('.popupContainer.is-open').removeClass('is-open');
                return false;
            });
        });

        if ($('.equipements_serie').length) {
            $(document).on('click', '.equipements_serie .eds_content .more', function (e) {
                e.stopPropagation();
                var cible = $(this).closest('.eds_content').data('cible');
                $('#' + cible).addClass('is-open');
            });
            $(document).on('click', '.equipements_serie .popupContainer .popup_close, .equipements_serie .popupContainer .popup_cover', function (e) {
                e.stopPropagation();
                $('.popupContainer.is-open').removeClass('is-open');
            });
      
        }
    });

});
